// /catalog: every Phoneware tier gets the whole catalog with its Autotask and
// OneBill links (screens/catalog/OpsCatalog), with the controls its tier holds; a
// dealer gets what it can quote, by category (screens/catalog/DealerCatalog).
import React from "react";
import { useSession } from "../session.js";
import { useTitle } from "../ui.js";
import { DealerCatalog } from "./catalog/DealerCatalog.js";
import { OpsCatalog } from "./catalog/OpsCatalog.js";

export function Catalog(): React.ReactElement {
  const { can } = useSession();
  useTitle("Catalog");
  return can("catalog.read_all") ? <OpsCatalog /> : <DealerCatalog />;
}
